import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateForecastRequest, Forecast } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateForecast() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateForecastRequest) =>
      apiPost<Forecast>('/v1/forecasts', input, {
        headers: { 'idempotency-key': crypto.randomUUID() },
      }),
    onSuccess: (f) => {
      void qc.invalidateQueries({ queryKey: ['forecasts'] });
      qc.setQueryData(['forecast', f.id], f);
    },
  });
}
